import { getValidUrl } from "./has-lang-code-param";

export const appendLangCode = (url: string, langCode: string): string => {
  const urlObj = getValidUrl(url);
  urlObj.searchParams.set('langCode', langCode);
  return urlObj.toString();
};
